// USA central point
export const MAP_DEFAULTS = {
  defaultCenter: {
    latitude: 39.50,
    longitude: -98.35
  },
  zoom: 4
}

export const DEFAULT_LOCATION_FINDER_HEADER_TEXT = 'You Have Not Saved a Location'
